/**
 * We use English comments only in this project.
 */
// Define libraries needed for Google Maps
import { Libraries } from '@react-google-maps/api';

// Explicitly define all required libraries
export const mapLibraries: Libraries = ["places", "geometry"];

// API key from environment
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || 'AIzaSyA9EIpN0YDtjS-r1EEh2bKqO-qklvHZ3_Q';

// Map defaults
export const defaultCenter = { lat: 18.7883, lng: 98.9853 }; // Chiang Mai City
export const defaultZoom = 14;
export const minZoom = 12;

// Map container styles
export const mapContainerStyle = {
  width: '100%',
  height: '100%',
};

// Bounds for the map display area (wider than service area)
export const displayBounds = {
  north: 19.2, // Slightly north of Chiang Mai
  south: 18.0, // Slightly south of Chiang Mai
  east: 99.5,  // Slightly east of Chiang Mai
  west: 98.5   // Slightly west of Chiang Mai
};

// Bounds for Chiang Mai Ring Road (approximate service area)
// Updated to properly cover all areas within the service polygon, including Mae Rim district
export const ringRoadBounds = {
  north: 18.95, // Expanded to cover Mae Rim district (18.936) with buffer
  south: 18.65, // Covers the southernmost point (18.655) with buffer  
  east: 99.07,  // Updated to cover the easternmost point (99.0512) with buffer
  west: 98.85   // Expanded to cover Mae Rim area (98.860) with buffer
};

// More precise definition of search bounds to prioritize local results
export const searchBounds = {
  north: 18.95, // Slightly wider than service area
  south: 18.60, // Extended to include Hang Dong area
  east: 99.15,  // Slightly wider than service area
  west: 98.85   // Slightly wider than service area
};

// Polygon coordinates for 2nd Ring Road (service boundary)
// Updated to include Hang Dong area including San Phak Wan subdistrict
export const expandedSecondRingCoordinates = [
  {
    "lat": 18.7155,
    "lng": 98.9762
  },
  {
    "lat": 18.7097,
    "lng": 98.971
  },
  {
    "lat": 18.7055,
    "lng": 98.9662
  },
  {
    "lat": 18.6989,
    "lng": 98.9566
  },
  {
    "lat": 18.6911,
    "lng": 98.9422
  },
  {
    "lat": 18.68,
    "lng": 98.94
  },
  {
    "lat": 18.67,
    "lng": 98.935
  },
  {
    "lat": 18.66,
    "lng": 98.93
  },
  {
    "lat": 18.655,
    "lng": 98.925
  },
  {
    "lat": 18.64292217139704,
    "lng": 98.90970031738281
  },
  {
    "lat": 18.650646138303006,
    "lng": 98.8886499786377
  },
  {
    "lat": 18.676706492038182,
    "lng": 98.90661041259766
  },
  {
    "lat": 18.6991106229705,
    "lng": 98.91801530151368
  },
  {
    "lat": 18.7119,
    "lng": 98.9199
  },
  {
    "lat": 18.723,
    "lng": 98.9144
  },
  {
    "lat": 18.7357,
    "lng": 98.9202
  },
  {
    "lat": 18.7487,
    "lng": 98.9285
  },
  {
    "lat": 18.7614,
    "lng": 98.9271
  },
  {
    "lat": 18.7711,
    "lng": 98.9405
  },
  {
    "lat": 18.7835,
    "lng": 98.9487
  },
  {
    "lat": 18.7981,
    "lng": 98.9425
  },
  {
    "lat": 18.8101,
    "lng": 98.9394
  },
  {
    "lat": 18.820962352144576,
    "lng": 98.94669633331299
  },
  {
    "lat": 18.839,
    "lng": 98.9515
  },
  {
    "lat": 18.8595,
    "lng": 98.9679
  },
  {
    "lat": 18.853,
    "lng": 98.9789
  },
  {
    "lat": 18.8507,
    "lng": 98.9906
  },
  {
    "lat": 18.8449,
    "lng": 99.0002
  },
  {
    "lat": 18.8351,
    "lng": 99.0067
  },
  {
    "lat": 18.8274,
    "lng": 99.0119
  },
  {
    "lat": 18.8208,
    "lng": 99.0225
  },
  {
    "lat": 18.810190554379993,
    "lng": 99.04072598419187
  },
  {
    "lat": 18.79368125462731,
    "lng": 99.04405749206543
  },
  {
    "lat": 18.77837240645068,
    "lng": 99.0512210952759
  },
  {
    "lat": 18.7549,
    "lng": 99.0407
  },
  {
    "lat": 18.747,
    "lng": 99.0301
  },
  {
    "lat": 18.7405,
    "lng": 99.0181
  },
  {
    "lat": 18.7376,
    "lng": 99.0005
  },
  {
    "lat": 18.7409,
    "lng": 98.9848
  },
  {
    "lat": 18.7299,
    "lng": 98.983
  },
  {
    "lat": 18.7155,
    "lng": 98.9762
  }
];

export const serviceAreaCoordinates = expandedSecondRingCoordinates;

// Pin style and animation
export const pinStyle = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -100%)',
  width: '30px',
  height: '38px',
  zIndex: 30,
  pointerEvents: 'none' as 'none',
  filter: 'drop-shadow(0 2px 2px rgba(0,0,0,0.3))'
};

export const pinAnimation = `
  @keyframes pinBounce {
    0% {
      transform: translate(-50%, -100%);
    }
    50% {
      transform: translate(-50%, -102%);
    }
    100% {
      transform: translate(-50%, -100%);
    }
  }
  @keyframes shadowPulse {
    0% {
      transform: translate(-50%, 0) scale(1);
      opacity: 0.5;
    }
    50% {
      transform: translate(-50%, 0) scale(0.95);
      opacity: 0.4;
    }
    100% {
      transform: translate(-50%, 0) scale(1);
      opacity: 0.5;
    }
  }
`; 